// const initialState = {
//   fontColor: 'pink', // default font color
// };

// export default function themeReducer(state = initialState, action) {
//   switch (action.type) {
//   case 'SET_FONT_COLOR':
//     return {
//       ...state,
//       fontColor: action.payload,
//     };
//   default:
//     return state;
//   }
// }



const initialState = {
  fontColor: '#184A61',
  fontFamily: 'Lato',
  backgroundColor: '#F6D5D6',
  ctaColor: '#DA6C74', // Default button color
  ctaHoverColor: '#DA6C74', // Default hover color
};
  
export default function themeReducer(state = initialState, action) {
  switch (action.type) {
  case 'SET_FONT_COLOR':
    return { ...state, fontColor: action.payload };

  case 'SET_FONT_FAMILY':
    return { ...state, fontFamily: action.payload };

  case 'SET_BACKGROUND_COLOR':
    return { ...state, backgroundColor: action.payload };

  case 'SET_CTA_COLOR':
    return { ...state, ctaColor: action.payload };

  case 'SET_CTA_HOVER_COLOR':
    return { ...state, ctaHoverColor: action.payload };

  default:
    return state;
  }
}
  